import { css } from '@emotion/core';
export var carousel = {
  name: "ea5dzg",
  styles: "position:absolute;margin:0 auto;width:100vw;height:100vh;"
};
export var lazyLoad = {
  name: "mikc7i",
  styles: "width:100%;height:100vh;"
};